<ng-container *ngrxLet="progress$ as progress">
  <usimweb-status-bar
    *ngIf="progress"
    style="top: 0px !important; height: 20px; display: inline-block"
    [mode]="'indeterminate'"></usimweb-status-bar>
</ng-container>

<div (click)="collapse()">
  <div *ngrxLet="data$ as data" class="container" style="max-width: 1500px">
    <div style="margin-top: 30px">
      <div style="display: inline-block">
        <p style="font-size: 22px; font-weight: bold">
          Available credits:
          <span *ngIf="data[0].available >= 0" style="color: #68dd01">
            {{ data[0].available | number : '' : 'de' }}</span
          >

          <span *ngIf="data[0].available < 0" style="color: red"> {{ data[0].available | number : '' : 'de' }}</span>
        </p>
      </div>

      <div style="display: inline-block; margin-left: 30px">
        <p style="font-size: 22px; font-weight: bold">Used credits: {{ data[0].total | number : '' : 'de' }}</p>
      </div>
    </div>

    <div class="row gx-10" style="margin-top: 30px">
      <div class="col-4">
        <app-chart [projects]="data[1]" [credits]="data[0].total"></app-chart>
      </div>

      <div class="col-7 offset-1">
        <usimweb-table-credits [data]="data[1]" (changeChart)="changeChart($event)"></usimweb-table-credits>
      </div>
    </div>
  </div>
</div>
